<template>
    <div>
        <view-item v-if="!!item" :item="item" @success="alertSuccess" @delete-item="deleteType" @cancel="item = false"
            @error="showError"></view-item>

        <list-items v-else title="RPA Tasks" @show-item="showItem" ref="table">
            <b-button id="add-bill-payment-btn" block variant="primary" v-if="hasPermissionCreate" @click="item = {}"><img v-b-tooltip.hover
                    :title="$addLabel()" src="@/assets/images/icon/blue-add.svg" /></b-button>
        </list-items>
    </div>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'
import utilityMixins from '@/mixins/utilityMixins'
import permissionsMixins from '@/mixins/permissionsMixins'
import errorHandlingMixins from '@/mixins/errorHandlingMixins'

import ListItems from './ListItems'
import ViewItem from './ViewItem'

export default {
    name: 'BillPaymentTo',
    components: {
        ListItems,
        ViewItem,
    },
    mixins: [
        popupMixins,
        utilityMixins,
        permissionsMixins,
        errorHandlingMixins,
    ],
    data: () => {
        return {
            item: null,
        }
    },
    mounted() {
    },
    computed: {
        componentName() { return this.$translate('bill_payment_to') },
        bill_payment_to() {
            const items =
                this.$store.state.billPaymentTo.items

                || []
            return items
        },
        user_permissions() {
            return this.$store.getters.user_permissions
        },
    },

    methods: {
        async doSearch() {
            await this.$store.dispatch('billPaymentTo/fetchAll')
        },

        showItem(id) {
            const item = this.bill_payment_to.find(x => x.id === id)
            this.item = { ...item }
        },

        alertSuccess(action, message) {
            console.log(this.item)
            this.genericToast(
                this.componentName,
                this.$translate(`${action}d`),
                'success',
                `${this.componentName
                } ${message}`
            )
            this.item = null
            this.doSearch()
        },

        showError(error) {
            this.genericToast(
                this.componentName,
                'Error',
                'danger',
                `${error.message}`
            )

        },
    },
}
</script>
<style></style>
